/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Pipeline Flow Source";
const frontMatter = {};
import {Mermaid} from "@theguild/remark-mermaid/mermaid";
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  return <Mermaid chart="flowchart LR\n    accTitle: Pipeline structure\n    accDescr: A simplified representation of a telemetry pipeline, which includes a source plugin, parser, processing rules, and destination plugin.\n    subgraph Pipeline structure\n        direction LR\n        A(Source plugin)\n        B(<a href=&quot;/pipeline-data/parsers&quot;>Parser</a>)\n        C(<a href=&quot;/pipeline-data/processing-rules&quot;>Processing rules</a>)\n        D(<a href=&quot;/pipeline-data/plugins/destination-plugins&quot;>Destination plugin</a>)\n        A --> B --> C --> D\n        style A stroke-width:4px\n    end" />;
}

export default MDXLayout